import { render, staticRenderFns } from "./AssignmentForm.vue?vue&type=template&id=75e9183f&scoped=true"
import script from "./AssignmentForm.vue?vue&type=script&lang=js"
export * from "./AssignmentForm.vue?vue&type=script&lang=js"
import style0 from "./AssignmentForm.vue?vue&type=style&index=0&id=75e9183f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e9183f",
  null
  
)

export default component.exports